import { ResultStatus } from "./resultStatus";
import { ScopePatternData } from "./scopePatternData";

export class FindOneScopePatternNumberResponse {
    scopePatternData?: ScopePatternData;
    status?: ResultStatus;
}